import serverCall from "../../serverCall";

const getUsage = (groupId) => {
  try {
    const response = serverCall.get(`/admin/usage?groupId=${groupId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const updateCaps = (groupId, body) => {
  try {
    const response = serverCall.patch(`/admin/usage/caps?groupId=${groupId}`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

const setTokenConfig = (body) => {
  return serverCall.post(`/admin/token-config`, body);
};

const getTokenConfig = () => {
  return serverCall.get(`/admin/token-config`);
};

const DashboardService = {
  getUsage,
  updateCaps,
  setTokenConfig,
  getTokenConfig,
};

export default DashboardService;
